// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICategorySummaryDto
 */
export interface ICategorySummaryDto {
    /**
     * 
     * @type {number}
     * @memberof ICategorySummaryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICategorySummaryDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICategorySummaryDto
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof ICategorySummaryDto
     */
    service_count?: number;
}

/**
 * Check if a given object implements the ICategorySummaryDto interface.
 */
export function instanceOfICategorySummaryDto(value: object): value is ICategorySummaryDto {
    return true;
}

export function ICategorySummaryDtoFromJSON(json: any): ICategorySummaryDto {
    return ICategorySummaryDtoFromJSONTyped(json, false);
}

export function ICategorySummaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICategorySummaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'service_count': json['service_count'] == null ? undefined : json['service_count'],
    };
}

export function ICategorySummaryDtoToJSON(json: any): ICategorySummaryDto {
    return ICategorySummaryDtoToJSONTyped(json, false);
}

export function ICategorySummaryDtoToJSONTyped(value?: ICategorySummaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'service_count': value['service_count'],
    };
}

